<template>
  <div>
    <div
      :class="
        props.show
          ? 'fixed top-0 transition-all left-0 right-0 w-full translate-x-[-0] bg-black h-[100vh]  z-[99999999999999]'
          : 'transform translate-x-[-140%]'
      "
    >
      <p class="text-[#000]">dadasdasdasdass</p>
      <div class="flex justify-between items-center px-7">
        <div>
          <svg
            @click="this.$emit('hide')"
            data-v-4fa0a2a1=""
            data-v-c853113a=""
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            role="button"
            class="icon-Sidemenu"
            width="40px"
            height="40px"
            viewBox="0 0 24 24"
            style="color: var(--primary)"
          >
            <path
              fill="currentColor"
              d="M3 18v-2h18v2H3Zm0-5v-2h18v2H3Zm0-5V6h18v2H3Z"
            ></path>
          </svg>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
          >
            <path
              d="M11.3976 5.17452C11.3025 5.73431 11.0027 6.2799 10.5445 6.73455L6.7809 10.4599C6.25929 10.9742 5.54748 11.2555 4.80398 11.2555C4.06047 11.2555 3.34866 10.9742 2.82705 10.4599L0.0172909 7.70069L0 0.0170495L7.79529 0L10.6079 2.77339C11.2563 3.41274 11.5416 4.28511 11.3976 5.17452Z"
              fill="#FFF000"
            />
            <path
              d="M26.8585 26.4522L19.066 26.4664L16.2505 23.6931C15.6021 23.0537 15.3168 22.1813 15.4609 21.2919C15.556 20.7293 15.8413 20.1837 16.3139 19.7319L19.9969 16.0833C20.5329 15.569 21.1986 15.2564 21.8787 15.2109H22.0545C22.8124 15.2109 23.5098 15.4923 24.0314 16.0208L26.844 18.78L26.8585 26.4494V26.4522Z"
              fill="#FFF000"
            />
            <path
              d="M26.8441 0.0170898V7.68652L24.1093 10.3832C23.5876 10.9117 22.9075 11.2243 22.2274 11.2556C21.4061 11.3181 20.6453 11.0225 20.0776 10.4599L19.6021 9.99389L7.52445 21.903L11.0489 20.36C11.6829 21.4341 11.5071 22.8066 10.608 23.696L7.80974 26.4694L0.017334 26.4836V18.7829L2.75217 16.0862C3.27378 15.5549 3.93659 15.2451 4.6167 15.2139C4.6801 15.2139 4.7435 15.1997 4.8069 15.1997C5.55041 15.1997 6.24492 15.4952 6.78382 16.0095L7.25644 16.4784L19.3341 4.56931L15.8096 6.11229C15.5243 5.64627 15.3975 5.11489 15.4292 4.56931C15.4754 3.89869 15.7924 3.22808 16.314 2.71375L19.0517 0.0170898H26.8441Z"
              fill="#FFF000"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
const props = defineProps({
  show: Boolean,
});
</script>
<style></style>
